
import PlaceCategoryMixin from "@/mixins/filter-genre.mixin";
import AreaMixin from "@/mixins/area.mixin";
import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";
import VueTypedMixin from "vue-typed-mixins";

export default VueTypedMixin(PlaceCategoryMixin, AreaMixin).extend({
  name: "component-filter-button",
  mixins: [PlaceCategoryMixin, AreaMixin],
  components: {
    MaterialIcons: () => import("@/components/common/material-icons.vue"),
  },
  props: {
    status: {
      type: String,
      required: true,
      validator: (value: string) => {
        return ["normal", "selected"].includes(value);
      },
    },
    name: String,
    // local image
    iconSrc: {
      type: String,
      required: false,
    },
    // remote image
    iconName: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    hide: Boolean,
    textOff: Boolean,
  },
  data: () => ({
    iconUri: process.env.VUE_APP_GENRE_ICON_URL ?? "",
  }),
  computed: {
    getLanguageWithoutCountry(): string {
      return this.$store.getters["data/getLanguageWithoutCountry"];
    },
    isMobile(): boolean {
      return this.$store.getters["ui/isMobile"];
    },
    selectedGenre(): PortalAdapterApi.PlaceCategoryType | "all" {
      return this.$store.state.data.selectedGenre;
    },
    hasTitle(): boolean {
      return this.title !== undefined && !this.textOff;
    },
    hasArea(): boolean {
      if (this.name === "area") {
        return this.hasSelectedAreaNameMixin;
      }
      return false;
    },
    hasGenre(): boolean {
      if (this.name === "genre") {
        return this.selectedGenre !== undefined && this.selectedGenre !== "all";
      }
      return false;
    },
    hasCategoryInDisasterPreventionMap(): boolean {
      if (this.selectedGenre === "disaster-prevention" && this.name === "tune") {
        return (this.selectedGenreCategoryList?.length ?? 0) > 0;
      }
      return false;
    },
    isEn(): boolean {
      return this.getLanguageWithoutCountry === "en";
    },
    isChecked(): boolean {
      return (
        this.hasSelectedFilter(this.name) || this.hasArea || this.hasGenre || this.hasCategoryInDisasterPreventionMap
      );
    },
    convertedTitle(): string {
      if (this.name === "area") {
        return !this.isChecked ? this.$i18n.t("Filter.searchTitle").toString() : this.title;
      }
      return this.title;
    },
  },
  methods: {
    btnCliked() {
      this.$emit("btn-clicked", this.name);
    },
    shrinkTitle(btnName: string, title: string, iconSrc: string): string {
      // エリアボタン
      if (btnName === "area") {
        if (this.getLanguageWithoutCountry === "en") {
          if (title.length > 8) {
            const shortTitle: string | undefined = title?.substring(0, 5);
            const newTitle: string | undefined = shortTitle?.concat("...");

            if (!newTitle) {
              return title;
            }
            return newTitle;
          } else {
            return title;
          }
        } else {
          if (title.length > 4) {
            const shortTitle: string | undefined = title?.substring(0, 3);
            const newTitle: string | undefined = shortTitle?.concat("...");

            if (!newTitle) {
              return title;
            }
            return newTitle;
          } else {
            return title;
          }
        }
      } else if (btnName === "genre") {
        if (!iconSrc) return this.$i18n.t("Nav.placeCateogory") as string;
        if (title.length > 3) {
          const shortTitle: string | undefined = title?.substring(0, 2);
          const newTitle: string | undefined = shortTitle?.concat("...");

          if (!newTitle) {
            return title;
          }
          return newTitle;
        } else {
          return title;
        }
      } else if (btnName === "favorite") {
        if (this.isEn && !this.isMobile) {
          return "Fave";
        }
      }
      return title;
    },
  },
});
